export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: CategoryItem[] = [
  { id: 'all', name: '全部', icon: 'ri-movie-2-line', description: '浏览所有类型影视作品', count: 12 },
  { id: '国产剧', name: '国产剧', icon: 'ri-tv-line', description: '最新热门国产电视剧', count: 5 },
  { id: '古装剧', name: '古装剧', icon: 'ri-sword-line', description: '古装仙侠武侠剧集', count: 2 },
  { id: '历史剧', name: '历史剧', icon: 'ri-building-line', description: '历史正剧与权谋大戏', count: 1 },
  { id: '电影', name: '电影', icon: 'ri-film-line', description: '院线大片在线观看', count: 3 },
  { id: '综艺', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺节目合集', count: 2 },
];

export const articleCategories = [
  { id: 'all', name: '全部文章' },
  { id: '影视资讯', name: '影视资讯' },
  { id: '深度影评', name: '深度影评' },
  { id: '独家专访', name: '独家专访' },
];